import { Injectable, Input } from '@angular/core';
import {
  ConfigService,
  ConfigBaseFilter,
  ListSortOption,
  ListLayout,
  ListLayoutMultipleComponent,
  SimpleConfigBaseFilter
} from 'gung-list';
import { MetadataService, SelectedCustomerService } from 'gung-standard';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs';
import { ColmecClaimGridViewComponent } from '../components/colmec-claim/colmec-claim-grid-view/colmec-claim-grid-view.component';
import { ColmecClaimTableViewComponent } from '../components/colmec-claim/colmec-claim-table-view/colmec-claim-table-view.component';
import { Claim, ColmecClaimService } from './colmec-claim.service';
import { gungComparatorHelper } from 'gung-common';

class ClaimKundReklamationBeskr extends SimpleConfigBaseFilter<Claim> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'ORKK_KUNDREKLAMATIONBESKR';
  }
  getOptionIds(item: Claim): string[] {
    const value = this.metadataService.getMetadataValue(
      'orkk',
      'kundreklamationbeskr',
      item.extra.ork.kundreklamationorsak
    );
    return [value];
  }
  getOptionName(key: string): string {
    return key;
  }
}

class ClaimWorkFlowFilter extends SimpleConfigBaseFilter<Claim> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'CLAIMWORKFLOW_CLAIMWORKFLOWDESCR';
  }
  getOptionIds(item: Claim): string[] {
    const value = this.metadataService.getMetadataValue(
      'claimworkflow',
      'claimworkflowdescr',
      item.extra.ork.claimworkflow
    );
    return [value];
  }
  getOptionName(key: string): string {
    return key;
  }
}

class ClaimActivityStatusFilter extends SimpleConfigBaseFilter<Claim> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'CLAIMACTIVITYSTATUS_CLAIMACTIVITYSTATUSDESCR';
  }
  getOptionIds(item: Claim): string[] {
    const value = this.metadataService.getMetadataValue(
      'claimactivitystatus',
      'claimactivitystatusdescr',
      item.extra.ork.claimactivitystatus
    );
    return [value];
  }
  getOptionName(key: string): string {
    return key;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ColmecClaimConfigListService implements ConfigService<Claim> {
  @Input()
  public customerId?: string;

  constructor(
    protected colmecClaimService: ColmecClaimService,
    protected selectedCustomerService: SelectedCustomerService,
    protected metadataService: MetadataService
  ) { }

  getItems(): Observable<Claim[]> {
    if (this.customerId) {
      return this.colmecClaimService.getClaims(this.customerId);
    }
    return this.colmecClaimService.getAllClaims();
    return this.selectedCustomerService.getSelectedCustomer().pipe(
      first(),
      switchMap(customer => this.colmecClaimService.getClaims(customer.id))
    );
  }

  getFilters(): ConfigBaseFilter<Claim>[] {
    return [
      new ClaimKundReklamationBeskr(this.metadataService),
      new ClaimWorkFlowFilter(this.metadataService),
      new ClaimActivityStatusFilter(this.metadataService)
    ];
  }

  getSortOptions(): ListSortOption<Claim>[] {
    return [
      {
        getLabel: () => 'ORDERNR_DESC',
        getComparator: () => (item1: Claim, item2: Claim) => gungComparatorHelper(item1?.extra.ork?.ordernr, item2?.extra.ork?.ordernr, -1)
      },
      {
        getLabel: () => 'ORDERNR_ASC',
        getComparator: () => (item1: Claim, item2: Claim) => gungComparatorHelper(item1?.extra.ork?.ordernr, item2?.extra.ork?.ordernr, 1)
      },
      {
        getLabel: () => 'ID_DESC',
        getComparator: () => (item1: Claim, item2: Claim) => gungComparatorHelper(item1?.extra.ork?.rmanr, item2?.extra.ork?.rmanr, -1)
      },
      {
        getLabel: () => 'ID_ASC',
        getComparator: () => (item1: Claim, item2: Claim) => gungComparatorHelper(item1?.extra.ork?.rmanr, item2?.extra.ork?.rmanr, 1)
      },
    ];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<Claim>[] {
    return [
      {
        getIconClass: () => 'fas fa-th-list',
        getListItemComponent: () => ColmecClaimTableViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ColmecClaimTableViewComponent'
      }
      // {
      //   getIconClass: () => 'fas fa-th-large',
      //   getListItemComponent: () => ColmecClaimGridViewComponent,
      //   getListLayoutComponent: () => ListLayoutMultipleComponent,
      //   getName: () => 'ColmecClaimGridViewComponent'
      // }
    ];
  }

  getSearchTerms(item: Claim): string[] {
    return [item.customerId, item.extra.ork.artnr];
  }

  getItemId(item: Claim): string {
    return item.customerId + '_' + item.extra.ork.artnr;
  }

  getNothingFoundTranslateTag() {
    return 'NOTHING_FOUND';
  }
}
